import * as c from "./constant"
import { combineReducers } from "redux";

export function dateRange(state = null, action) {
  switch (action.type) {
    case c.UPDATE_DATE_RANGE:
      return action.range;
    case c.CLEAR_FILTER:
      return null;
    default:
      return state;
  }
}

export default combineReducers({ dateRange });
